<template>
  <div class="deslocation row align-center">
    <div class="ball align-end justify-center column">
      <img src="../../assets/img/gps.svg" />
    </div>
    <div class="warning">
      Seu check-in
      <strong>está concluído</strong>
    </div>
    <span>FECHANDO EM {{ count }}...</span>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.deslocation {
  width: 550px;
  height: 200px;
  background: $blue-6;
  color: $white;
  overflow: hidden;
  border-radius: 23px;

  .ball {
    margin-right: 31px;
    background: $white;
    border-radius: 50%;
    width: 305px;
    height: 275px;
    text-align: center;
    margin-left: -175px;
    padding-right: 50px;
  }

  .warning {
    font-size: 26px;
    width: 240px;
  }
  span {
    font-size: 15px;
    margin-left: 15px;
    padding-right: 20px;
    width: 160px;
  }
}
</style>

<script>
export default {
  name: "Checkin",
  props: {
    modal: Object,
  },
  components: {},
  data() {
    return {
      count: 5,
    };
  },
  methods: {
    county() {
      if (this.count > 0) {
        this.count = this.count - 1;
        setTimeout(() => {
          this.county();
        }, 1000);
      } else {
        this.modal.show = false;
      }
    },
  },
  mounted() {
    this.county()
  },
  computed: {},
};
</script>
